import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  cellContainer: {
    height: 38,
    width: CELL_WIDTHS.VALUE.SMALL,
    minWidth: CELL_WIDTHS.VALUE.SMALL,
  },
  cellExpanded: {
    width: CELL_WIDTHS.VALUE.XXSMALL * 4,// + 10,
    minWidth: CELL_WIDTHS.VALUE.XXSMALL * 4,// + 10
  },
  weekCell: {
    width: CELL_WIDTHS.VALUE.XXSMALL,
    minWidth: CELL_WIDTHS.VALUE.XXSMALL
  },
  button: {
    right: -8,
    zIndex: 3
  },
}));

export default useStyle;
